// Types
const action_header = "errorManager/";

export default {
  SERVER_SIDE_ERROR_HANDLER: action_header + "SERVER_SIDE_ERROR_HANDLER",
};
